import '../../sass/auth/index.scss';
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from '../core/reducers/configureStore';
import installGlobalErrorReporter from '@common/helpers/installGlobalErrorReporter';

installGlobalErrorReporter('transcription-auth');
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {resources} from "../core/i18n/resources";
import Index from "./components/Index";
import SiteReducer from "../core/reducers/SiteReducer";
import {siteSetData} from "../core/actions/SiteActions";
import DictionaryReducer from "../core/reducers/DictionaryReducer";
import CountryReducer from "../core/reducers/CountryReducer";
import UserReducer from "../core/reducers/UserReducer";

const store = configureStore({
    site: SiteReducer,
    dictionary: DictionaryReducer,
    country: CountryReducer,
    user: UserReducer,
});

window.rootElement = document.getElementById('transcription-auth-app');

const dataset = rootElement.dataset;

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: dataset.lang,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

store.dispatch(siteSetData({
    lang: dataset.lang,
    socialAuthStatus: !!parseInt(dataset.socialAuthStatus),
    facebookAppId: dataset.facebookAppId,
    googleAppId: dataset.googleAppId,
    signUpEnabled: !!parseInt(dataset.signUpEnabled),
}));

render(
    <Provider store={store}>
        <Index />
    </Provider>,
    rootElement
);
